module.exports = __webpack_public_path__ + "static/media/location_icon.4af5b0c0.svg";